export const applyPolyfills = async () => {
    try {
        // String.replaceAll polyfill
        if (!String.prototype.replaceAll) {
            console.info('Add String.replaceAll polyfill');
            const replaceAllPolyfill = await import('string.prototype.replaceall');
            replaceAllPolyfill.shim();
        }

        // Intl.Locale polyfill
        if (!("Locale" in Intl)) {
            console.info('Add Intl.Locale polyfill');
            await import('@formatjs/intl-locale/polyfill')
        }

        // Intl.PluralRules polyfill
        if (!("PluralRules" in Intl)) {
            console.info('Add Intl.PluralRules polyfill');
            await import('@formatjs/intl-pluralrules/polyfill-force')
            await import(`@formatjs/intl-pluralrules/locale-data/en`)
            await import(`@formatjs/intl-pluralrules/locale-data/fr`)
        }

        // Intl.RelativeTimeFormat polyfill
        if (!("RelativeTimeFormat" in Intl)) {
            console.info('Add Intl.RelativeTimeFormat polyfill');
            await import('@formatjs/intl-relativetimeformat/polyfill')
            await import('@formatjs/intl-relativetimeformat/locale-data/en')
            await import('@formatjs/intl-relativetimeformat/locale-data/fr')
        }

        // crypto.randomUUID polyfill
        if (!('randomUUID' in crypto)) {
            console.info('Add crypto.randomUUID polyfill');
            // https://stackoverflow.com/a/2117523/2800218
            crypto.randomUUID = function randomUUID() {
                return (
                    [1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g,
                        c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
                    );
            };
        }

    } catch (err) {
        console.error('Polyfill setup error', err);
    }
}